import React from 'react';
import {Route, Routes, useLocation  } from 'react-router';
import { AnimatePresence } from 'framer-motion';
import ScrollToTop from './componentes/ScrollTop';
import Error404 from './componentes/Error404'
import PaginaDeInicio from './paginas/PaginaInicio';
import PaginaPertinas from './paginas/PaginaPertinas';
import PaginaPersianas from './paginas/PaginaPersianas';
import TelasParaCortina from './paginas/TelasParaCortina';
import DetallePersiana from './paginas/DetallesPersiana';
import DetallesPertina from './paginas/DetallesPertina';
import DetallesTelasParaCortinas from './paginas/DetallesTelasParaCortinas';
import PaginasLambrin from './paginas/PaginaLambrin';
import DetallesLambrin from './paginas/DetallesLambrin';
import PaginaToldos from './paginas/PaginaToldos';
import DetallesToldos from './paginas/DetallesToldos';
import PaginaVertilux from './paginas/PaginaVertilux';
import DetallesVertilux from './paginas/DetallesVertilux';
import PaginaTejidosExclusivos from './paginas/PaginaTejidosExclusivos';
import DetallesTejidosExclusivos from './paginas/DetallesTejidosExclusivos';
import PaginaSuperOfertas from './paginas/PaginaSuperOfertas';
import DetallesSuperOfertas from './paginas/DetallesSuperOfertas';
import Estadisticas from './componentes/Estadisticas';
import { useEffect } from 'react';
import { incrementVisit } from "./visitCounter";


function App() {
  const location = useLocation();
  useEffect(() => {
    incrementVisit();
  }, []);
  return (
      <AnimatePresence mode="wait">
        <ScrollToTop></ScrollToTop>
        <Routes location={location} key={location.pathname}>
        <Route path="/estadisticas-hi-blinds-382dkf8s" element={<Estadisticas />} />
          <Route path='/*' element={ <Error404 />}/>
          <Route path="/" element={<PaginaDeInicio />} />
          <Route path="/pertina" element={<PaginaPertinas />} />
          <Route path="/persianas" element={<PaginaPersianas />} />
          <Route path="/telas-para-cortina-y-confección" element={<TelasParaCortina />} />
          <Route path="/lambrin" element={<PaginasLambrin />} />
          <Route path="/toldos" element={<PaginaToldos />} />
          <Route path="/telas-premium-vertilux" element={<PaginaVertilux />} />
          <Route path="/tejidos-exclusivos" element={<PaginaTejidosExclusivos />} />
          <Route path="/super-ofertas" element={<PaginaSuperOfertas />} />
          
          <Route path="/persianas/:categoriaSlug/:slug" element={<DetallePersiana />} />
          <Route path="/pertina/:slug" element={<DetallesPertina />} />
          <Route path="/telas-para-cortina-y-confección/:slug" element={<DetallesTelasParaCortinas />} />
          <Route path="/lambrin/:slug" element={<DetallesLambrin />} />
          <Route path="/toldos/:slug" element={<DetallesToldos />} />
          <Route path="/telas-premium-vertilux/:slug" element={<DetallesVertilux />} />
          <Route path="/tejidos-exclusivos/:slug" element={<DetallesTejidosExclusivos />} />
          <Route path="/super-ofertas/:slug" element={<DetallesSuperOfertas />} />
        </Routes>
      </AnimatePresence>
  );
}

export default App;
